export default function ({ store, redirect }) {
    // If the user is not authenticated
    if (!store.state.employer.isEmpLoggedIn) {
      return redirect('/tefl-jobs-centre/post-a-job')
    }
  }